
<c-contract-editor
    :title     = "$t('contract.lim.fulltitle')"
    :unit-data = "unitData"
    :terminate = "true"
    @store     = "onStore"
    @edit      = "onEdit"
    @start     = "onStart"
    @end       = "onEnd"
>
 </c-contract-editor>
